import React from "react";
import { Reveal, Overline } from "./Reveal";
import { Check } from "lucide-react";

const PERKS = [
  "Firm capital from day one — no personal risk",
  "Institutional-grade execution & market data",
  "Dedicated risk, quant and engineering support",
  "Uncapped, performance-aligned profit share",
  "A structured Trainee Track for emerging talent",
  "A close-knit trading floor built for focus, not scale",
];

export const Careers = () => (
  <section id="careers" data-testid="careers" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
      <div className="lg:col-span-5">
        <Reveal><Overline>Careers</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05]">
            Trade like it's yours. Because the upside is.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-mute leading-relaxed mt-8 text-lg">
            We are always looking for traders with genuine edge and the discipline to defend it. If that sounds like you, the next move is one form away.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <button
            data-testid="careers-apply-btn"
            onClick={() => document.querySelector("#apply")?.scrollIntoView({ behavior: "smooth" })}
            className="mt-10 font-mono text-xs uppercase tracking-[0.2em] border border-brass text-brass px-7 py-4 hover:bg-brass hover:text-ink transition-colors"
          >
            Start your application
          </button>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-line border border-line">
          {PERKS.map((p, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <div className="bg-ink p-8 h-full flex items-start gap-4 hover:bg-surface transition-colors">
                <Check size={18} className="text-brass shrink-0 mt-1" />
                <span className="text-bone leading-relaxed">{p}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
